import { auth } from './firebase';

// Resposta de /api/briefing/send (mesmo contrato do server.ts e da Netlify Function).
export interface BriefingSendResponse {
  success: boolean;
  realSend?: boolean;
  simulated?: boolean;
  recipientCount?: number;
  successCount?: number;
  failCount?: number;
  errors?: string[];
  message?: string;
  error?: string;
}

const SERVER_UNAVAILABLE =
  'O serviço de envio de e-mails não respondeu como esperado (a função do Netlify pode não estar publicada). Nenhum e-mail foi enviado.';

/**
 * Chama /api/briefing/send com o ID token do Firebase do usuário logado.
 * Lança Error com mensagem em pt-BR para sessão ausente/expirada (401),
 * falta de permissão (403) ou resposta que não seja JSON.
 */
export async function postBriefing(body: object): Promise<BriefingSendResponse> {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('Você precisa estar logado como administrador para enviar o briefing. Faça login novamente.');
  }

  let idToken: string;
  try {
    // getIdToken() renova o token automaticamente se estiver perto de expirar.
    idToken = await currentUser.getIdToken();
  } catch {
    throw new Error('Não foi possível validar sua sessão. Faça login novamente e tente outra vez.');
  }

  const resp = await fetch('/api/briefing/send', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    body: JSON.stringify(body)
  });

  if (resp.status === 401) {
    throw new Error('Sessão inválida ou expirada: faça login novamente como administrador. Nenhum e-mail foi enviado.');
  }
  if (resp.status === 403) {
    throw new Error('Sua conta não tem permissão de administrador para disparar o briefing. Nenhum e-mail foi enviado.');
  }

  const isJson = (resp.headers.get('content-type') || '').includes('application/json');
  if (!isJson) throw new Error(SERVER_UNAVAILABLE);

  return resp.json();
}
